export default {
  update: 'currentPlanUpdate',
}
